import React from "react";
import {
  DataGrid,
  Selection,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../components/PaginaToolbar";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import uiInfo from "../ui-info";
import apiAxios from "../api-axios";
import { Button } from "devextreme-react/button";
import UserInfo from "../UserInfo";
import notify from "devextreme/ui/notify";

export default class UnificaoCadastrosBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      algoritmosDs: [],
      criteriosDs: [],
      gridDs: [],
      filtro: {
        algoritmo: null,
        criterio: null,
      },
      registros: [],
      loading: false,
    };

    this.pesquisar = this.pesquisar.bind(this);
    this.limparCampos = this.limparCampos.bind(this);
    this.executar = this.executar.bind(this);

    this.algoritmoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      valueExpr: "codigo",
      displayExpr: "codigo",
    };

    this.criteriosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      valueExpr: "nome",
      displayExpr: "nome",
    };
  }

  async componentDidMount() {
    const response = await apiAxios.get("unificarcadastros/start");

    this.setState({
      ...this.state,
      algoritmosDs: response.data,
    });
  }

  async pesquisar() {
    const response = await apiAxios.get(
      "unificarcadastros/pesquisar/" +
        this.state.filtro.algoritmo +
        "/" +
        this.state.filtro.criterio +
        "/" +
        UserInfo.getPrefeitura()
    );

    this.setState({
      ...this.state,
      gridDs: response.data,
    });
  }

  async executar() {
    this.setState({ ...this.state, loading: true });

    await apiAxios.post(
      "unificarcadastros/executar/" + UserInfo.getPrefeitura(),
      this.state.registros
    );

    this.setState({ ...this.state, loading: false });

    notify("Executado com sucesso!", "success");

    this.limparCampos();
  }

  limparCampos() {
    this.setState({
      ...this.state,
      filtro: {
        algoritmo: null,
        criterio: null,
      },
      gridDs: null,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form
              formData={this.state.filtro}
              colCount={2}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField={"algoritmo"}
                editorType={"dxLookup"}
                editorOptions={{
                  ...this.algoritmoOptions,
                  dataSource: this.state.algoritmosDs,
                  onSelectionChanged: (e) => {
                    this.setState({
                      ...this.state,
                      criteriosDs:
                        e.selectedItem &&
                        e.selectedItem.criterios.map((item, index) => ({
                          id: index,
                          nome: item,
                        })),
                    });
                  },
                }}
              >
                <Label text="Algoritmo" />
              </SimpleItem>
              <SimpleItem
                dataField={"criterio"}
                editorType={"dxLookup"}
                editorOptions={{
                  ...this.criteriosOptions,
                  dataSource: this.state.criteriosDs,
                }}
              >
                <Label text="Critério" />
              </SimpleItem>
            </Form>
            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Pesquisar"
                  type="success"
                  onClick={this.pesquisar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Executar" onClick={this.executar} disabled={this.state.loading} />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Campos" onClick={this.limparCampos} />
              </div>
            </div>
          </form>
          <br />
          <br />
          <PaginaToolbar titulo="" ocultarNovo={true}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.gridDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
              onSelectionChanged={(e) =>
                this.setState({ ...this.state, registros: e.selectedRowKeys })
              }
            >
              <Selection
                mode="multiple"
                selectAllMode="allPages"
                showCheckBoxesMode="always"
              />
              <Column dataField={"origem"} width={500} dataType={"date"} />
              <Column dataField={"destino"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }
}
